import { Pipe, PipeTransform } from '@angular/core';
import { MancoToCheckUpOn } from './manco-to-check-up-on';

@Pipe({
  name: 'mancosToCheckUpOnSearch',
})
export class MancosToCheckUpOnSearchPipe implements PipeTransform {
  transform(items: MancoToCheckUpOn[], searchText: string): MancoToCheckUpOn[] {
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();

    return items.filter(
      manco =>
        this.optionalContains(searchText, manco.caseNumber) ||
        this.optionalContains(searchText, manco.customerNumber) ||
        this.optionalContains(searchText, manco.ticketNumber) ||
        this.optionalContains(searchText, manco.note) ||
        this.optionalContains(searchText, manco.returnNumber) ||
        manco.treatmentDate.toLowerCase().includes(searchText) ||
        manco.checkDate.toLowerCase().includes(searchText) ||
        this.optionalContains(searchText, manco.createdBy) ||
        this.optionalContains(searchText, manco.updatedBy)
    );
  }

  optionalContains(searchText: string, value?: string | null) {
    if (value === undefined || value === null) {
      return false;
    }
    return value.toLowerCase().includes(searchText);
  }
}
